import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Image, Layout } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import './index.css';
import GeneralHelper from '../helpers/general';
import LocalStorageHelper from '../helpers/local_storage';
const { Content } = Layout;

export class NavigationLayout extends Component {
	render() {
		const { location } = this.props.children.props;
		const email = LocalStorageHelper.getEmail();
		return (
			<Layout>
				<div style={{ height: 20, width: '100%', backgroundColor: '#003366' }}></div>
				<div className="navigation-layout-header">
					<div className="navigation-layout-header-left">
						<Image
							className="navigation-layout-header-left-logo"
							preview={false}
							src={`${GeneralHelper.getImageBasePath()}/images/logo.png`}
						/>
						<div className="navigation-layout-header-left-separator" />
						<div
							className="navigation-layout-header-left-product"
						><span>CAMPUS SERVICES OFFICE</span></div>
					</div>
					{email ? <div className="navigation-layout-header-logout">
						<span>You are logged in as {email}</span>
						<span style={{ marginLeft: 10, marginRight: 10 }}>|</span>
						<Link
							to="/logout"
							style={{ color: '#003366' }}
						>
							<LogoutOutlined
								style={{ paddingRight: 4 }}
							/>
							Logout
						</Link>
					</div> : <div className="navigation-layout-header-login">
						<Link
							to={`/login?path=${location.pathname + location.search + location.hash}`}
							style={{ fontSize: 14, fontWeight: 'bold', color: '#FFFFFF', backgroundColor: '#013972', border: '1px solid black', padding: '5px 35px' }}
						>
							Login
						</Link>
					</div>}
				</div>
				<Content
					style={{
						display: 'flex',
						justifyContent: 'center'
					}}
				>
					{this.props.children}
				</Content>
			</Layout>
		);
	}
}

export default NavigationLayout;
